export const undefinedNullFormatter = (returnValue) => {
  switch(returnValue) {
    case 'dash': return '-';
    case 'na': return 'NA';
    case 'null': return '';
    case 'zero': return '0';

    default: return '-';
  }
}